import { useAuthStore } from '@/store/authStore'
import type { OrderListParams } from '@/api/orders'
import { isCustomerManager, isCustomerSupervisor } from '@/utils/access'

/**
 * Возвращает дополнительные параметры фильтрации заказов на основе роли
 * текущего пользователя. Для сотрудников Стрижа — пустой объект (видят всё).
 */
export function useRoleOrderParams(): Partial<OrderListParams> {
  const profile = useAuthStore((s) => s.profile)

  if (isCustomerManager(profile)) {
    return { managerId: profile!.id }
  }

  if (isCustomerSupervisor(profile)) {
    return { companyId: profile!.company_id ?? undefined }
  }

  return {}
}
